/**
 * Er denne opplastingsfeilen «fila ligger der alt»?
 *
 * Rapporter og dokumenter lastes opp med `upsert: false`, fordi det som er
 * levert aldri skal overskrives — se
 * `supabase/migrations/20261029130000_rapporter_og_dokumenter_overskrives_ikke.sql`.
 * Da maa klienten taale aa moete sin egen forrige opplasting.
 *
 * Det skjer helt normalt: svaret paa en vellykket opplasting kan gaa tapt
 * paa vei tilbake — telefonen mister nettet i samme sekund — og neste
 * forsoek sender den samme fila til den samme stien. Uten denne proeven
 * ville koen staatt fast for alltid paa en fil som allerede er framme.
 *
 * Stien baerer versjonen, og en gitt versjon har de samme bytesene. «Den
 * ligger der alt» betyr derfor «den er levert», ikke «noe gikk galt».
 */
export function finnesAlt(feil: unknown): boolean {
  if (typeof feil !== "object" || feil === null) return false;
  const o = feil as Record<string, unknown>;
  // supabase-js legger HTTP-statusen i `statusCode`, som streng.
  if (o["statusCode"] === "409" || o["statusCode"] === 409) return true;
  if (o["error"] === "Duplicate") return true;
  const melding = typeof o["message"] === "string" ? o["message"] : "";
  return /already exists|resource already|duplicate/i.test(melding);
}
